import React from "react";
import { useSearchParams } from "react-router-dom";
import { IconUserPlus, IconHierarchy } from "@tabler/icons-react";
import PageContent from "../shared/PageContent/PageContent";
import SubNav from "../shared/Navigation/SubNav";
import LeadsTab from "./LeadsTab";
import DownlineTab from "./DownlineTab";

const TAB_PARAM = "tab";

const REPS_TABS = [
  { id: "leads", label: "Leads", icon: IconUserPlus },
  // Opens on the Downline view, as on iOS
  { id: "org", label: "Org", icon: IconHierarchy },
];

const DEFAULT_TAB = REPS_TABS[0].id;

function RepsPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get(TAB_PARAM);
  const activeTab = REPS_TABS.some(tab => tab.id === tabParam)
    ? tabParam
    : DEFAULT_TAB;

  const handleTabChange = tab => {
    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev);
        if (tab.id === DEFAULT_TAB) {
          next.delete(TAB_PARAM);
        } else {
          next.set(TAB_PARAM, tab.id);
        }
        // Each tab keeps its own params; drop them on switch
        [...next.keys()]
          .filter(key => key !== TAB_PARAM)
          .forEach(key => next.delete(key));
        return next;
      },
      { replace: true }
    );
  };

  return (
    <PageContent
      customHeader={
        <SubNav
          tabs={REPS_TABS}
          activeId={activeTab}
          onChange={handleTabChange}
          ariaLabel="Reps sections"
        />
      }
    >
      {activeTab === "leads" && <LeadsTab />}
      {activeTab === "org" && <DownlineTab />}
    </PageContent>
  );
}

export default RepsPage;
